



export const mapperAtencionMedica = (atencionMedica) => {
  
  if( !atencionMedica ) return null;

  const itemAtencionAuditar = {
    idPaciente       : atencionMedica.cita.paciente.id,
    idAte            : atencionMedica.id,
    token            : atencionMedica.token,
    tipoConsulta     : atencionMedica.tipoConsulta,
    cita             : atencionMedica.cita,
    establecimiento  : atencionMedica.cita.establecimiento.id,
    signature        : atencionMedica.signature,
    docAs400         : atencionMedica.cita.documentoscitaSet,
    docConsentimiento: atencionMedica.urlConsentimiento,
    estadoRevision   : atencionMedica.estadoRev,
    semiologia       : atencionMedica.semiologia
  }
  
  return itemAtencionAuditar;

}